<div class="clipboard-input-container">
   <label for="clipboard-input" class="hidecontentlabel">{{'hiden_clipboard_input' | i18nv2 }}</label>
   <textarea readonly id="clipboard-input"></textarea>
</div>
<div style='display: none;'>
   <ng-template class="toastContentBox" #clipboardComponent>
      <span class='toastContent'>{{'CONFIRM_COPY' | i18nv2 }}</span>
      <button (click)='confirmClipboardToast()' type="button" id="clipboardOkBtn" class="btn btn-primary toastButton">{{'OK' | i18nv2 }}</button>
   </ng-template>
</div>